import { Component ,OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import * as Aos from 'aos';
@Component({
  selector: 'app-tour-and-travels',
  templateUrl: './tour-and-travels.component.html',
  styleUrls: ['./tour-and-travels.component.scss']
})
export class TourAndTravelsComponent implements OnInit  {
   
  constructor(
    private titleService: Title,
  )
  {    }

  ngOnInit(){
    this.titleService.setTitle('Tour And Travels');

    setTimeout(() => {
      Aos.init();
    }, 500);       
      Aos.refresh();
  }
}
